export const waitFor = function (selectors, callback) {
  if (document.querySelectorAll(selectors).length < selectors.length) {
    setTimeout(waitFor.bind(null, selectors, callback), 200)
  } else {
    callback()
  }
}

export const waitForObserver = (selectors, callback) => {
  waitFor(selectors, () => {
    const observer = new MutationObserver((mutations, observer) => {
      callback()
    })
    selectors.forEach((selector) => {
      observer.observe(document.querySelector(selector), { attributes: true, childList: true, subtree: true })
    })
  })
}
